export interface BusEvent {
  readonly name: string
  readonly payload: unknown
}

type ListenerList = ((e: BusEvent) => void)[]

export class EventBus {
  private listenersMap = new Map<string, ListenerList>()

  public emit (e: BusEvent): void {
    const listeners = this.listenersMap.get(e.name) || []
    listeners.forEach(l => {
      l(e)
    })
  }

  public listen (name: string, listener: (e: BusEvent) => void): void {
    const listeners = this.listenersMap.get(name) || []
    listeners.push(listener)
    this.listenersMap.set(name, listeners)
  }
}

export const eventBus = new EventBus()
